import React, { useEffect, useState } from "react";
import { FaRegCircleDot } from "react-icons/fa6";
import LearnerCentricApproach  from '../../../assets/LearnerCentricApproach.png';
import CollaborationImg from '../../../assets/Collaboration.png';
import ProgressiveLearning from '../../../assets/ProgressiveLearning.png';

const capabilities = [
    {
        title: "Learner-Centric Approach",
        description:
            "We prioritize the needs and goals of our learners, providing personalized learning paths and adaptive content.",
        image: LearnerCentricApproach,
    },
    {
        title: "Collaboration",
        description:
            "We foster collaboration through peer learning, mentor guidance, and shared growth opportunities.",
        image: CollaborationImg,
    },
    {
        title: "Progressive Learning",
        description:
            "We promote continuous growth through evolving courses, skill upgrades, and lifelong learning opportunities.",
        image: ProgressiveLearning,
    },
];

const Info = [
    {
        title: "Learn",
        description: "Access structured courses designed for clarity and depth.",
    },
    {
        title: "Practice",
        description:
            "Apply knowledge through real-world projects and assignments.",
    },
    {
        title: "Track",
        description: "Monitor performance with smart insights and feedback.",
    },
    {
        title: "Grow",
        description:
            "Continuously improve with mentorship and career guidance.",
    },
];

export const OurCapabilities = () => {
    const [active, setActive] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setActive((prev) => (prev + 1) % capabilities.length);
        }, 4000);

        return () => clearInterval(interval);
    }, []);

    return (
        <section className="py-16 bg-secondary-50 overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 space-y-10">

                {/* TITLE */}
                <h1 className="text-primary-800 text-[24px] sm:text-[35px] md:text-[45px] font-bold text-center">
                    Our Capabilities
                </h1>

                {/* TOP TABS */}
                <div className="grid md:grid-cols-3 gap-6">

                    {capabilities.map((item, index) => (
                        <div key={index} className="space-y-3">

                            {/* PROGRESS BAR */}
                            <div className="p-1 bg-secondary-100 w-full relative overflow-hidden rounded-full">
                                {active === index && (
                                    <div className="absolute left-0 top-0 h-full bg-primary-600 animate-progress"></div>
                                )}
                            </div>

                            <h3
                                className={`font-semibold text-2xl ${active === index ? "text-black" : "text-gray-400"
                                    }`}
                            >
                                {item.title}
                            </h3>

                            <p
                                className={`text-lg ${active === index ? "text-gray-600" : "text-gray-300"
                                    }`}
                            >
                                {item.description}
                            </p>

                        </div>
                    ))}

                </div>

                {/* IMAGE SECTION */}
                <div className="relative w-full overflow-hidden h-[350px] rounded-xl">

                    {capabilities.map((item, index) => (
                        <div
                            key={index}
                            className={`absolute inset-0 transition-opacity duration-700 ${active === index ? "opacity-100" : "opacity-0"
                                }`}
                        >

                            <img
                                src={item.image}
                                alt={item.title}
                                className="w-full h-full object-cover"
                            />

                            {/* DARK OVERLAY */}
                            <div className="absolute inset-0 bg-black/20"></div>

                        </div>
                    ))}

                </div>

                {/* INFO SECTION */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">

                    {Info.map((item, index) => (
                        <div key={index} className="space-y-2">

                            <p className="text-secondary-400 text-xl">
                                <FaRegCircleDot />
                            </p>

                            <h3 className="text-xl font-semibold">
                                {item.title}
                            </h3>

                            <p className="text-gray-600">
                                {item.description}
                            </p>

                        </div>
                    ))}

                </div>

            </div>
        </section>
    );
};